const features = [
  {
    title: 'TreeVault Cloud Services',
    description:
      'Keep your research safe and accessible. TreeVault syncs your family tree across devices with automatic backups, so you can work from your laptop, tablet, or desktop without missing a beat.',
  },
  {
    title: 'Charting & Reports',
    description:
      'Build pedigree charts, descendant trees, and fan charts with professional layouts. Customize colors, fonts, and formats to create keepsakes worthy of framing.',
  },
  {
    title: 'Media Management',
    description:
      'Attach photos, documents, and recordings to every person in your tree. Advanced tagging and search help you find exactly what you need when you need it.',
  },
  {
    title: 'Color Coding & Smart Matching',
    description:
      'Organize research by color and spot relationships at a glance. Smart matching flags potential duplicates so you can merge records with confidence.',
  },
  {
    title: 'FamilySync & Hints',
    description:
      'Connect to FamilySearch and explore billions of records. Intelligent hints surface possible ancestor matches—saving time and deepening your discoveries.',
  },
  {
    title: 'FamilySearch Integration',
    description:
      'Search, attach, and verify FamilySearch records without leaving Family Tree Maker. Stay current with the latest features as they release.',
  },
];

export default function Features() {
  return (
    <section className="py-20 bg-[#fff]" id="about">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-[#2d2520] mb-6">
          Welcome to Family Tree Maker
        </h2>
        <div className="section-divider w-24 mx-auto mb-12" />

        <div className="max-w-3xl mx-auto mb-16 text-center">
          <p className="text-[#4a4038] text-lg md:text-xl leading-relaxed mb-4">
            Family Tree Maker is the most trusted genealogy software for preserving your family history—combining
            powerful research tools with an intuitive interface that grows with you.
          </p>
          <p className="text-[#5a534a] text-base md:text-lg leading-relaxed">
            Whether you&apos;re new to genealogy or managing a large tree, you&apos;ll find everything you need
            to document and share your heritage for generations to come.
          </p>
        </div>

        <h3 className="text-2xl md:text-3xl font-bold text-center text-[#2d2520] mb-10">
          Why Choose Family Tree Maker?
        </h3>

        <div className="max-w-4xl mx-auto grid md:grid-cols-2 gap-8">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="group p-6 rounded-xl bg-[#fefdfb] border border-[#e8e2d8] hover:border-[#22c55e]/40 hover:shadow-md transition-all duration-300"
            >
              <h4 className="text-lg font-bold text-[#2d2520] mb-3 group-hover:text-[#16a34a] transition-colors">
                {feature.title}
              </h4>
              <p className="text-[#5a534a] leading-relaxed text-[15px]">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
